import _toConsumableArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _isEqual from "lodash/isEqual";
import "core-js/modules/es6.array.map.js";
import { createSelector } from 'reselect';
import memoize from 'lru-memoize';
var emptyParamsIngest = function emptyParamsIngest() {
  return [];
};
var configureSelector = function configureSelector(inputSelector, params) {
  // Case it's a normal selector
  if (inputSelector.func === undefined) return inputSelector;

  // Otherwise, configure it to receive the parameters
  var func = inputSelector.func,
    _inputSelector$params = inputSelector.paramsIngest,
    paramsIngest = _inputSelector$params === void 0 ? emptyParamsIngest : _inputSelector$params;
  return func.apply(void 0, _toConsumableArray(paramsIngest.apply(void 0, _toConsumableArray(params))));
};

// based on https://www.aarongreenwald.com/blog/redux-reselect-parameters
/**
 *
 * @param {*} selector The selector to memoize
 * @param {*} options an object with different configuration options:
 *        - inputSelectors: The selectors that prepare the input the selector will take,
 *          look at reselect's input selectors for more information:
 *          https://redux.js.org/usage/deriving-data-selectors#writing-memoized-selectors-with-reselect
 *          (identity by default)
 *        - maxCachedKeys: The amount of concurrent memoized selectors of this type
 *          with different parameters supported (4 by default)
 *        - comparisonOperator: The comparison operator to determine selector's keys,
 *          (_.isEqual by default)
 * @returns a memoized by params selector that also uses reselect
 */
var createMemoizedSelector = function createMemoizedSelector(selector) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$maxCachedKey = options.maxCachedKeys,
    maxCachedKeys = _options$maxCachedKey === void 0 ? 4 : _options$maxCachedKey,
    _options$inputSelecto = options.inputSelectors,
    inputSelectors = _options$inputSelecto === void 0 ? [function (state) {
      return state;
    }] : _options$inputSelecto,
    _options$comparisonOp = options.comparisonOperator,
    comparisonOperator = _options$comparisonOp === void 0 ? _isEqual : _options$comparisonOp;
  var inputSelectorsArray = inputSelectors;
  if (!Array.isArray(inputSelectors)) {
    inputSelectorsArray = [inputSelectors];
  }
  var makerFunction = function makerFunction() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    return createSelector(inputSelectorsArray.map(function (inputSelector) {
      return configureSelector(inputSelector, params);
    }), selector.apply(void 0, params));
  };
  return memoize(maxCachedKeys, comparisonOperator)(makerFunction);
};
export default createMemoizedSelector;